<ng-container *ngIf="openTextLabel; else imageOpenLabel">
  <span
    (click)="handleAction()"
    class="text-primary cursor-pointer fw-bold text-decoration-underline"
    >{{ actionLabel }}</span
  >
</ng-container>

<ng-template #imageOpenLabel>
  <div class="use-img-preview">
    <div
      class="img-container cursor-pointer"
      [class.h-auto]="!height"
      [class.w-auto]="!width"
      [class.justify-content-start]="!centerImage"
      [ngStyle]="{
        height: height ? height + 'px' : null,
        width: width ? width + 'px' : null,
        borderRadius: borderRadius ? borderRadius + 'px' : null,
        overflow: borderRadius ? 'hidden' : null,
      }"
      (click)="handleAction()"
    >
      <img
        src="{{ images?.length ? (images ? images[0] : null) : '' }}"
        alt="..."
        [class.mw-100]="!width"
        [ngClass]="imgClass"
        [ngStyle]="width && height ? { width: '100%', height: '100%', objectFit: 'cover' } : null"
        (error)="handleNoImage($event)"
      />
    </div>
  </div>
</ng-template>

<app-modal
  #modalImage
  [modalConfig]="modalImageConfig"
  [modalOptions]="modalImageOptions"
  [modalClass]="'modal-image-preview'"
>
  <div cardBody class="d-flex w-100 justify-content-between flex-column">
    <h1 class="text-white">{{ titleModal }}</h1>
    <div class="my-4" #swiperWrapper>
      <swiper [config]="config" class="swiper-main" #swiperCarousel>
        <ng-template swiperSlide *ngFor="let img of images; index as i">
          <div class="image-preview">
            <div
              class="image-preview-draggable"
              [style]="currentZoom < 2 ? 'pointer-events: none' : ''"
              id="imagePreview_{{ i }}"
            >
              <img
                src="{{ img }}"
                class="img-fluid"
                alt="img-preview-{{ i }}"
                draggable="false"
                (error)="handleNoImage($event)"
                style="{{
                  activeSlideIndex === i
                    ? ' transform: translate(' +
                      panX +
                      'px, ' +
                      panY +
                      'px) scale(' +
                      currentZoom +
                      ') rotate(' +
                      currentRotation +
                      'deg) '
                    : ''
                }}"
              />
            </div>
          </div>
        </ng-template>
      </swiper>

      <!--  ACTIONS: -->
      <div
        #actionsRow
        class="image-preview-actions d-flex align-items-center justify-content-center gap-5 mt-4"
      >
        <span class="cursor-pointer">
          <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_ZOOM_IN"></span>
        </span>
        <span class="cursor-pointer">
          <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_ZOOM_OUT"></span>
        </span>
        <span class="cursor-pointer">
          <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_ROTATE_LEFT"></span>
        </span>
        <span class="cursor-pointer">
          <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_ROTATE_RIGHT"></span>
        </span>
      </div>

      <!-- THUMBNAIL PAGINATION: -->
      <!--      <div-->
      <!--        *ngIf="images && images.length > 1"-->
      <!--        class="d-flex gap-3 align-items-center justify-content-center"-->
      <!--      >-->
      <!--        <div-->
      <!--          *ngFor="let img of images; index as i"-->
      <!--          class="image-pagination cursor-pointer"-->
      <!--          [class.active-image]="activeSlideIndex === i"-->
      <!--          (click)="goToSlide(i)"-->
      <!--        >-->
      <!--          <img-->
      <!--            src="{{ img }}"-->
      <!--            class="img-fluid"-->
      <!--            alt="img-preview-{{ i }}"-->
      <!--            (error)="handleNoImage($event)"-->
      <!--          />-->
      <!--        </div>-->
      <!--      </div>-->

      <div
        class="swiper-thumbs-container mt-4"
        *ngIf="useThumbnail"
        [ngClass]="{ 'thumbs-center': (images?.length || 0) < 5 }"
      >
        <swiper
          #thumbsSwiper
          class="swiper-thumbs"
          [slidesPerView]="5"
          [spaceBetween]="10"
          (swiper)="onThumbsInit($event)"
        >
          <ng-template swiperSlide *ngFor="let img of images; index as i">
            <div
              class="thumb-wrapper"
              [class.active]="activeSlideIndex === i"
              (click)="goToSlide(i)"
            >
              <img
                [src]="img"
                class="img-thumbnail"
                alt="thumb-{{ i }}"
                (error)="handleNoImage($event)"
              />
            </div>
          </ng-template>
        </swiper>
      </div>
    </div>
  </div>
</app-modal>
